import ReactPlayer from 'react-player'

const VideoPlayer = ({url}) => {
  return (
    <ReactPlayer url={url} controls loop={false} onContextMenu={e => e.preventDefault()} config={{ file: { attributes: { controlsList: 'nodownload' } } }} width={'100%'} />
  )
}

export default VideoPlayer